//Boilerplate
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import xlsx from "xlsx";

//Our Stuff
import { MSpinner, MSelect, MGrid, MCard } from "components/Shared";
import { FORMATTER_RIGHT_ALIGN, FORMATTER_LEFT_ALIGN } from "components/Shared/MGrid.tsx";
import { getPayPeriodList } from "actions/casetimelog";
import { DATA_TYPE_DATE_WITHDOW } from "typeConstants/dataTypes";
import { defaultMaxHeightStyle } from "styles/sharedStyles";

export const CELL_NEGATIVE_RED_FORMATTER = ({ value }) => {
  if (value.includes("(") && value.includes(")")) {
    return (
      <div style={{ color: "#c8102e" }}>{value}</div>
    );
  }
  return (
    <div>{value}</div>
  );
};
CELL_NEGATIVE_RED_FORMATTER.propTypes = {
  value: PropTypes.string
};

class MacCard extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = "MacList";
    this.handlePayPeriodChange = this.handlePayPeriodChange.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.getPendingPayPeriods = this.getPendingPayPeriods.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.getQAMacBonusDisplay = this.getQAMacBonusDisplay.bind(this);
    this.refresh = this.refresh.bind(this);
    this.downloadGrid = this.downloadGrid.bind(this);
    this.state = {
      payPeriodSelected: "",
      pendingPayPeriods: []
    };
  }  

  componentDidUpdate(prevProps) {
    // Called only when we stop fetching payPeriods
    if (prevProps.isFetchingPayPeriods && !this.props.isFetchingPayPeriods) {
      let pendingPayPeriods = this.getPendingPayPeriods();
      if (pendingPayPeriods) {
        this.setState({
          payPeriodSelected: pendingPayPeriods[0],
          pendingPayPeriods: pendingPayPeriods
        });
        this.props.getPaySummary(
          this.props.employeeID,
          pendingPayPeriods[0].id
        );
      }
    }

    const { payPeriod, employeeID, getPaySummary } = this.props;
    if (payPeriod && (payPeriod != prevProps.payPeriod || employeeID !== prevProps.employeeID)) {
      this.setState({
        payPeriodSelected: payPeriod,
      });
      getPaySummary(
        employeeID,
        payPeriod.id
      );
    }
  }

  UNSAFE_componentWillMount() {
    const { payPeriods, getPayPeriodList, payPeriod } = this.props;
    //Get List of payPeriods if we don't already have them
    if (payPeriods.length === 0) {
      getPayPeriodList();
    } else {
      let pendingPayPeriods = this.getPendingPayPeriods();
      const payPeriodSelected = payPeriod || pendingPayPeriods[0];
      this.setState({
        pendingPayPeriods: pendingPayPeriods,
        payPeriodSelected: payPeriodSelected,
      });
      this.props.getPaySummary(
        this.props.employeeID,
        payPeriodSelected.id
      );
    }
  }

  getColumns() {
    const { paySummary } = this.props;
    const { columns } = paySummary;
    let colWithFormatter = cloneDeep(columns);
    for (let i = 0; i < colWithFormatter.length; i++) {
      if (colWithFormatter[i].formatter === "Negative-Red") {
        colWithFormatter[i].formatter = CELL_NEGATIVE_RED_FORMATTER;
      }
    }
    colWithFormatter = colWithFormatter.map(x => x.key === "controlIdNumber" || x.key === "mac" || x.key === "costPrevious" || x.key === "macRemaining" ? 
    ({ key: x.key, 
      name: x.name, 
      dataSource: x.key, 
      filterType: "FILTER_TYPE_NONE", 
      formatter: FORMATTER_RIGHT_ALIGN }) : x.key === "submittedDate" ?
        ({ key: x.key, 
          name: x.name, 
          dataSource: x.key, 
          filterType: "FILTER_TYPE_NONE", 
          formatter: FORMATTER_LEFT_ALIGN,
          dataType: DATA_TYPE_DATE_WITHDOW,
        }) : 
          ({ key: x.key,
            name: x.name,
            dataSource: x.key,
            filterType: "FILTER_TYPE_NONE"
          })
      );
    return colWithFormatter;
  }

  getPendingPayPeriods() {
    let pendingPayPeriods = [];
    for (let i = 0; i < this.props.payPeriods.length; i++) {
      let element = this.props.payPeriods[i];
      if (!element.closedDate) {
        pendingPayPeriods.push(element);
      } else {
        // included one not pending pay period
        pendingPayPeriods.push(element);
        break;
      }
    }
    return pendingPayPeriods;
  }

  handlePayPeriodChange(option) {
    let payPeriod = this.props.payPeriods.find(x => x.id == option.value);
    this.setState({ payPeriodSelected: payPeriod });
    this.props.getPaySummary(this.props.employeeID, option.value);
  }

  getQAMacBonusDisplay() {
    if (this.props.paySummary &&
      (
        this.props.paySummary.macBonusPotential &&
        this.props.paySummary.nonProductionCostTotal &&
        this.props.paySummary.macBonus
      )) {
      return (
        <div plain="true" className="summary-container">
          <span className="summary-span"><b className="summary-label">MAC Bonus Potential:</b> <span className="summary-text">{this.props.paySummary.macBonusPotential}</span></span>
          <span className="summary-span"><b className="summary-label">Non-Production Cost Total:</b> <span className="summary-text">{this.props.paySummary.nonProductionCostTotal}</span></span>
          <span className="summary-span"><b className="summary-label">MAC Bonus:</b> <span className="summary-text">{this.props.paySummary.macBonus}</span></span>
        </div>
      );
    }
    return (<></>);
  }

  getOptions() {
    const { paySummary } = this.props;
    let title = this.props.FRMac
      ? `MAC: $${paySummary.totalMac}`
      : this.getQAMacBonusDisplay(paySummary);
    let options = {
      description: paySummary.payPeriodCases.length + " items found.",
      rowType: "mac",
      title: title
    };
    return options;
  }

  refresh() {
    this.props.getPaySummary(this.props.employeeID, this.state.payPeriodSelected.id);
  }

  downloadGrid() {
    // download the grid as an xlsx file
    // documentation https://github.com/SheetJS/js-xlsx#array-of-arrays-input
    if (!this.props.paySummary || this.props.paySummary.payPeriodCases.length < 1) return;
    const columns = this.getColumns();
    const rows = this.props.getRows(this.props.paySummary);
    let wsCols = [];
    columns.forEach(c => {
      wsCols.push(c.key);
    });
    let wsRows = [];
    let headerRow = {};
    columns.forEach(c => {
      headerRow[c.key] = c.name;
    });
    wsRows.push(headerRow);
    rows.forEach(r => {
      wsRows.push(r);
    });
    if (this.props.paySummary.isSalaried) { // reformat excel document if appraiser is salaried
      // must manually add these headerRow names since column for salaried appraisers only includes "Control #" and "mac"
      headerRow["surveyCity"] = "Survey City"; 
      headerRow["surveyType"] = "Survey Type";
      headerRow["weeklySalary"] = "Salary";
      headerRow["overtimeCost"] = "Overtime";
      headerRow["macBonus"] = "MAC Bonus";
      wsRows.forEach(x => {
        delete x.costCurrent;
        delete x.costPrevious;
        delete x.costTotal;
        delete x.macRemaining;
        delete x.timeCurrent;
        delete x.returnedDeduction;
        delete x.lateDeduction;
        if (x.controlIdNumber === "Total") {
          x["weeklySalary"] = this.props.paySummary.weeklySalary;
          x["overtimeCost"] = this.props.paySummary.overtimeCost;
          x["macBonus"] = this.props.paySummary.macBonus;
        } else if (x.controlIdNumber !== "Control #") delete x.macBonus;
      });
    } 
    let wb = xlsx.utils.book_new();
    let ws = xlsx.utils.json_to_sheet(wsRows, {
      header: wsCols,
      skipHeader: true
    });
    xlsx.utils.book_append_sheet(wb, ws, "Sheet 1");
    xlsx.writeFile(wb, this.state.payPeriodSelected.fromToDisplay + ".xlsx");
  }

  render() {
    const {
      payPeriods,
      isFetchingPayPeriods,
      isFetchingPayPeriodSummary,
      paySummary,
      footerContent,
      getRows,
      FRMac,
      cardSx,
    } = this.props;
    const {
      payPeriodSelected, 
    } = this.state;

    if (payPeriods.length === 0) {
      return <MSpinner />;
    }

    if (isFetchingPayPeriods) {
      return <MSpinner />;
    }

    if (!paySummary) {
      return <MSpinner />;
    }

    if (isFetchingPayPeriodSummary) {
      return <MSpinner />;
    }

    const data = getRows(paySummary);
    const actions = [
      { icon: "refresh", helpText: "Refresh", onClick: this.refresh },
      { icon: "download", helpText: "Download", onClick: this.downloadGrid },
    ];
    return (
      <MCard className="mac-list-card card-unnested profile-card" title="MAC Log" actions={actions} sx={cardSx}>
        <div className="card-content">
          <div className="pay-period-container">
            {!this.props.hidePayPeriodSelection &&
              <MSelect
                className="pay-period-dropdown"
                isClearable={false}
                onChange={this.handlePayPeriodChange}
                options={payPeriods.map(x => ({
                  value: x.id,
                  label: x.fromToDisplay
                }))}
                value={payPeriodSelected.fromToDisplay}
              />
            }
          </div>
          {FRMac
            ? 
            <div className="summary-container">
              <span className="summary-span"><b className="summary-label">MAC Bonus: </b><span className="summary-text">{paySummary.macBonus}</span></span>
              <span className="summary-span"><b className="summary-label">{data.length} items found</b></span>
            </div>
            : this.getQAMacBonusDisplay()}
          <div className="mac-grid-wrapper">
            {data && data.length > 0 ? (
              <div className="appraiser-mac-log">
                <MGrid
                  columnDefinitions={this.getColumns()}
                  dataLastChanged={Date.now()}
                  data={data}
                />
                {paySummary.isSalaried &&  
                  (<div className="summary-container-appraiser">
                    <span className="summary-span"><b className="summary-label">Weekly Salary: </b><span className="summary-text">{paySummary.weeklySalary}</span></span>
                    <span className="summary-span"><b className="summary-label">Overtime: </b><span className="summary-text">{paySummary.overtimeCost}</span></span>
                    <span className="summary-span"><b className="summary-label">MAC Bonus: </b><span className="summary-text">{paySummary.macBonus}</span></span>
                  </div>)}
              </div>)
              : <p className="no-data-message">No data available for this pay period.</p>
            }
          </div>
          {footerContent && footerContent()}
        </div>
      </MCard>
    );
  }
}

MacCard.defaultProps = {
  payPeriods: new Array(),
  paySummary: null,
  headerContent: null,
  footerContent: null,
  hidePayPeriodSelection: false,
  cardSx: defaultMaxHeightStyle,
};

MacCard.propTypes = {
  //Pure Props
  employeeID: PropTypes.number,
  isFetchingPayPeriodSummary: PropTypes.bool,
  paySummary: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  getRows: PropTypes.func,
  getPaySummary: PropTypes.func,
  headerContent: PropTypes.func,
  footerContent: PropTypes.func,
  FRMac: PropTypes.bool,
  payPeriod: PropTypes.object,
  hidePayPeriodSelection: PropTypes.bool,
  cardSx: PropTypes.object,

  //Redux Store State
  payPeriods: PropTypes.array,
  isFetchingPayPeriods: PropTypes.bool,

  //Redux Actions
  getPayPeriodList: PropTypes.func,
};

const mapStateToProps = state => ({
  //Pay Period Sumary
  payPeriods: state.caseTimeLog.payPeriods,
  isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
});

const mapDispatchToProps = dispatch => ({
  getPayPeriodList() {
    dispatch(getPayPeriodList());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MacCard);
